<template>
    <div>
        {{ trans('activities.events.task.resolved') }} <b>{{ item.subject?.code }}</b>
        <div>
            <small :class="getTaskResolutionColor(item.subject?.resolution?.value, 'text')"
                ><b>{{ item.subject?.resolution?.label }}</b></small
            >&nbsp;<small>{{ item.subject?.type?.label }}</small>
        </div>
    </div>
</template>
<script setup>
import { getTaskResolutionColor } from '@/Pages/TaskList/utils.js';
import { trans } from '@/mixins/i18n.js';

defineProps({ item: Object });
</script>
